<template>
  <modal :show="show" @close="close">
    <v-flex slot="title">{{ !!id ? 'Edytuj' : 'Dodaj kontener' }}</v-flex>

    <div>
      <v-layout column>
        <v-flex xs12>
          <w-schema :model="$schema.name">
            <v-text-field name="name" label="Nazwa kontenera*" />
          </w-schema>
        </v-flex>
      </v-layout>

      <span class="caption grey--text">*oznaczone pola są wymagane</span>
    </div>

    <v-layout slot="actions">
      <v-spacer />

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { tryParseInt } from '@witkac/utils/tryParseInt';
import { WSchema } from '@witkac/vuetify-components';
import { mapState } from 'vuex';

import Modal from '@/components/material/Modal';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/pointContainer.schema';

const emptyData = () => ({
  name: '',
  partnerId: null
});

// @vuese
// Modal dodawania/edycji kontenera
// @group Partners
export default {
  components: { Modal, WSchema },
  mixins: [manageMixin('partners/pointContainers', {}, emptyData)],
  schema,
  computed: {
    ...mapState({
      stateData: state => state.partners.pointContainers.data
    })
  },
  watch: {
    show(val) {
      if (val) {
        this.setData();
        this.setPartnerId();
      }
    }
  },
  methods: {
    // @vuese
    // Ustawienie pola w schemie
    setPartnerId() {
      this.$schema.partnerId.$setData(tryParseInt(this.$route.params.id));
    }
  }
};
</script>
